<app-article-header></app-article-header>
<div class="page-container" style="background-color: #fff;">
  <div class="article_page_body row">
    <div class="article_details col-md-10">
      <img
           [src]="articleDetails?.largeImagePath? baseImageUrl+articleDetails.largeImagePath :'./assets/images/user.png'"
           onerror="this.src='./assets/images/user.png'" alt="">
      <p class="article_header">{{articleDetails?.name}}</p>
      <div [innerHTML]="articleDetails?.content"></div>
    </div>
<!--    <div class="col-md-1"></div>-->
    <div class="col-sm-12 col-md-2 other_articles">
      <ng-template [ngIf]="showCarousel">
        <div style="height: 200px;width: 100%">


              <owl-carousel-o class="customSlider row" [style.direction]="('dir' | translate) === 'rtl' ? 'ltr' : 'ltr'"
                              [options]="customOptions">
                <ng-template carouselSlide *ngFor="let article of articles">
                  <div [dir]="_translate.currentLang == 'ar' ? 'rtl' : 'ltr'" class="articleCard" (click)="navigateToArticle(article.id)">
                    <img [src]="article.smallImagePath? baseImageUrl+article.smallImagePath :'./assets/images/user.png'" onerror="this.src='./assets/images/user.png'" alt="">
                    <div class="break_line"></div>
                    <p class="serviceTitle">{{article.name | translate}}</p>
                    <!--        <p class="serviceDescription">{{article.description | translate | truncate:[250, "..."]}}</p>-->

                  </div>
                </ng-template>
              </owl-carousel-o>
        </div>
      </ng-template>
      <ng-template [ngIf]="!showCarousel">
        <div style="height: 100vh;overflow-y: scroll">
          <div *ngFor="let article of articles"
               [dir]="_translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
               class="articleCard" (click)="navigateToArticle(article.id)">
            <div class="row articleCard" >
              <img [src]="article.smallImagePath? baseImageUrl+article.smallImagePath :'./assets/images/user.png'"
                   onerror="this.src='./assets/images/user.png'" alt="">
              <div class="break_line"></div>
              <p class="serviceTitle">{{article.name | translate}}</p>
            </div>
          </div>

        </div>
      </ng-template>

    </div>
  </div>
</div>
<app-index-footer [lang]="currLang"></app-index-footer>
